import React, { memo, useCallback, useState } from 'react';
import { Icon, Tabs } from '@Sage/hoi-poi-ui';

import './styles.scss';

const TAB_CLASSES = {
    root: 'fm-drawer-tabs__tabs-root',
    navContainer: 'fm-drawer-tabs__tabs-nav-container',
    nav: 'fm-drawer-tabs__tabs-nav',
    tab: 'fm-drawer-tabs__tabs-tab',
    tabActive: 'fm-drawer-tabs__tabs-tab-active',
    inkBar: 'fm-drawer-tabs__tabs-inkbar',
    tabWithPopover: 'fm-drawer-tabs__tabs-tab-with-popover',
    navArrowBase: 'fm-drawer-tabs__tabs-nav-arrow-base',
    navPrev: 'fm-drawer-tabs__tabs-nav-prev',
    navNext: 'fm-drawer-tabs__tabs-nav-next',
};

const DrawerTabs = memo(
    ({ tabs, defaultActiveTab, onClose, className, panelsClassName, onTabChange }) => {
        const initialTab = defaultActiveTab ?? tabs?.[0]?.key;

        const [activeTab, setActiveTab] = useState(initialTab);
        const [mountedTabs, setMountedTabs] = useState(() => new Set([initialTab]));

        const handleTabChange = useCallback(
            (key) => {
                setActiveTab(key);
                setMountedTabs((prev) => {
                    if (prev.has(key)) return prev;
                    const next = new Set(prev);
                    next.add(key);
                    return next;
                });
                onTabChange?.(key);
            },
            [onTabChange],
        );

        const tabDefs = tabs?.map(({ key, title }) => ({
            key,
            title: (
                <div
                    className={`fm-drawer-tabs__tab-title${activeTab === key ? ' fm-drawer-tabs__tab-title--active' : ''}`}
                >
                    {title}
                </div>
            ),
        }));

        return (
            <div className={`fm-drawer-tabs${className ? ` ${className}` : ''}`}>
                <div className="fm-drawer-tabs__header">
                    <Icon
                        name="close"
                        size="medium"
                        onClick={onClose}
                        className="fm-drawer-tabs__close"
                    />
                    <Tabs
                        className="fm-drawer-tabs__tabs"
                        classes={TAB_CLASSES}
                        tabs={tabDefs}
                        activeKey={activeTab}
                        onChange={handleTabChange}
                        editable={false}
                    />
                </div>
                <div
                    className={`fm-drawer-tabs__panels${panelsClassName ? ` ${panelsClassName}` : ''}`}
                >
                    {tabs?.map(({ key, content }) =>
                        mountedTabs.has(key) ? (
                            <div
                                key={key}
                                className={`fm-drawer-tabs__panel${activeTab !== key ? ' fm-drawer-tabs__panel--hidden' : ''}`}
                            >
                                {content}
                            </div>
                        ) : null,
                    )}
                </div>
            </div>
        );
    },
);

export default DrawerTabs;
